import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import SecureFormItem from "@/common/SecureFormItem";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { SCHEMA_NAME } from "@/util/common_variable";
import { Button, Form } from "antd";
import { useEffect } from "react";

export const MODE = { NEW: "NEW", EDIT: "EDIT" };

const AssignmentsModal = ({
  show,
  handleCancel,
  formSubmit,
  selectAssignment = null,
  bookingsFieldsEnabled = true,
  startingPoint = "",
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isNonEmptyVariable(selectAssignment)) {
      form.setFieldsValue(selectAssignment);
    } else {
      form.resetFields();
    }
  }, [selectAssignment]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const data = {
        ...values,
        startDate: isNonEmptyVariable(values?.startDate)
          ? values?.startDate?.format("MM/DD/YYYY")
          : null,
        endDate: isNonEmptyVariable(values?.endDate)
          ? values?.endDate?.format("MM/DD/YYYY")
          : null,
      };
      formSubmit(data);
      form.resetFields();
    });
  };
  function handleFormCancel() {
    form.resetFields();
    handleCancel();
  }
  return (
    <>
      <Modal
        show={show}
        header={`${selectAssignment ? "VIEW" : "ADD"} Assignment Information`}
        onHide={handleFormCancel}
        handleCancel={handleFormCancel}
        handleSubmit={handleSubmit}
        designPattern="ant"
        width="60%"
        footerActions={[
          <Button
            key="SUBMIT"
            onClick={handleFormCancel}
            disabled={!bookingsFieldsEnabled}
          >
            Close
          </Button>,
          <Button
            key="SUBMIT"
            onClick={handleSubmit}
            disabled={!bookingsFieldsEnabled}
          >
            Save
          </Button>,
        ]}
      >
        <FieldSecurityProvider
          entity={SCHEMA_NAME.STAFF_SERVICE_HR}
          startingPoint={startingPoint}
          bookingsFieldsEnabled={bookingsFieldsEnabled}
        >
          <Form form={form} disabled={!bookingsFieldsEnabled}>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={12}>
                <SecureFormItem
                  fieldName={["servicesHr", 0, "assignment"]}
                  formItemProps={{
                    name: ["servicesHr", 0, "assignment"],
                    label: "Assignment",
                  }}
                  entityOverride={SCHEMA_NAME.SERVICES_HR}
                >
                  <Select
                    id="assignment"
                    options={getOptionsFromRefList("Staff_Assignment")}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={12}>
                <SecureFormItem
                  fieldName={["servicesHr", 0, "assignmentType"]}
                  formItemProps={{
                    name: ["servicesHr", 0, "assignmentType"],
                    label: "Assignment Type",
                  }}
                  entityOverride={SCHEMA_NAME.SERVICES_HR}
                >
                  <Select
                    name="assignmentType"
                    id="assignmentType"
                    options={getOptionsFromRefList("Staff_Assignment_Type")}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={12}>
                <SecureFormItem
                  fieldName="startDate"
                  formItemProps={{ name: "startDate", label: "Start Date" }}
                >
                  <CommonDatePicker
                    placeholder={"Start Date"}
                    showTime={false}
                    format="MM/DD/YYYY"
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={12}>
                <SecureFormItem
                  fieldName="endDate"
                  formItemProps={{ name: "endDate", label: "End Date" }}
                >
                  <CommonDatePicker
                    placeholder={"End Date"}
                    showTime={false}
                    format="MM/DD/YYYY"
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={24}>
                <SecureFormItem
                  fieldName={["servicesHr", 0, "comment"]}
                  formItemProps={{
                    name: ["servicesHr", 0, "comment"],
                    label: "Comment",
                  }}
                  entityOverride={SCHEMA_NAME.SERVICES_HR}
                >
                  <TextField inputType="textarea" id="comment" rows={5} />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
          </Form>
        </FieldSecurityProvider>
      </Modal>
    </>
  );
};

export default AssignmentsModal;
